import {ImageFormatFamilies} from '../constants';

export const isImageFileTypeAsset = (fileFormatFamily: string[] = []) =>
	fileFormatFamily.length > 0 &&
	fileFormatFamily.some((format) =>
		ImageFormatFamilies.includes(
			format as (typeof ImageFormatFamilies)[number],
		),
	);

export default isImageFileTypeAsset;
